import classes from "./typical-header.module.scss";

function TypicalHeader({ iconSrc, iconAlt, headerText }) {
  return (
    <div className={classes.typical_header}>
      <img
        src={iconSrc}
        alt={iconAlt}
        className={classes["typical-header-icon"]}
      />
      <div className="flex flex-ai-c flex-columngap-8">
        <span className={classes["typical-header-text"]}>{headerText}</span>
      </div>
    </div>
  );
}

export default TypicalHeader;
